import React, { Component } from "react";
import { connect } from "react-redux";
import { change, Field, reduxForm } from "redux-form";
import { Button, Modal } from "react-bootstrap";
import PsInput from "./PsInput";
import { email, required, telefon } from "../../validation";
import { inputsFormName } from "../../selectors/inputsSelectors";

class PsLeadModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: true
    };
  }
  render() {
    return (
      <div>
        <Modal show={this.state.showModal}>
          <Modal.Header>
            <Modal.Title>
              Nur noch ein Schritt zum Kostenvoranschlag
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Ihre Anfrage wurde erfolgreich berechnet.</h4>
            <p>
              Bitte geben Sie uns zum Abschluss noch kurz Ihre Kontaktdaten an.
            </p>
            <Field
              name="vorname"
              label="Ihr Vorname *"
              component={PsInput}
              validate={[required]}
            />
            <Field
              name="nachname"
              label="Ihr Nachname *"
              component={PsInput}
              validate={[required]}
            />
            <Field
              name="unternehmen"
              label="Ihr Unternehmen *"
              component={PsInput}
              validate={[required]}
            />
            <Field
              name="email"
              label="Ihre Email *"
              component={PsInput}
              validate={[required, email]}
            />
            <Field
              name="telefon"
              label="Ihre Telefonnummer *"
              component={PsInput}
              validate={[required, telefon]}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              disabled={this.props.pristine || !this.props.valid}
              bsStyle="success"
              type="submit"
              onClick={this.props.handleSubmit(values => {
                console.log("values", values);
                this.setState({ showModal: false });
                fetch(process.env.REACT_APP_BACKEND_URL + "/prod/sendMail", {
                  method: "POST",
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify(this.props.reduxstate)
                })
                  .then(response => {
                    if (response.ok) {
                      return;
                    }
                    console.error(response);
                  })
                  .catch(error => {
                    console.error(error);
                  });
              })}
            >
              Zum Ergebnis
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    reduxstate: state
  };
};

const Connected = connect(mapStateToProps)(PsLeadModal);

export default reduxForm({
  form: "kontaktForm",
  initialValues: {
    vorname: "",
    nachname: "",
    unternehmen: "",
    email: "",
    telefon: ""
  }
})(Connected);



// WEBPACK FOOTER //
// ./src/components/inputs/PsLeadModal.js